import React from 'react';
import * as yup from 'yup';
import { useFormik, FormikProvider, Form } from 'formik';
import { storageSet } from 'src/utils';
import { H3, Paragraph } from 'src/components/reusable/Typography';
import {
  FormGroup,
  Input,
  InputPassword,
  Label
} from 'src/components/reusable/Forms';
import { Button } from 'src/components/reusable/Buttons';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/path';

interface LoginFormProps {
  openRegister: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ openRegister }) => {
  const navigate = useNavigate();
  const validationRules = yup.object().shape({
    email: yup.string().required('Required').email('Invalid email address'),
    password: yup
      .string()
      .required('Required')
      .min(8, 'Must be 8 characters or more')
      .matches(
        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        'One Uppercase, One Lowercase, One Number and one special case Character'
      )
  });

  const formik = useFormik({
    initialValues: {
      validateOnMount: true,
      email: '',
      password: ''
    },
    validationSchema: validationRules,
    onSubmit: async (values) => {
      console.log({ values });
      storageSet('token', values);
      navigate(PATH_DASHBOARD.general.send_gift_card);
    }
  });

  const { values, getFieldProps, handleSubmit, isValid, dirty } = formik;
  return (
    <div className="login-form py-6">
      <div className="text-left mb-10 flex flex-col gap-y-4">
        <H3>Login</H3>
        <div>
          <Paragraph className="text-base md:text-[18px] font-medium text-body-tertiary">
            Welcome back.
          </Paragraph>
          <Paragraph className="text-base md:text-[18px] font-medium  text-body-tertiary">
            Send gift cards, view transactions and manage your account
          </Paragraph>
        </div>
      </div>
      <FormikProvider value={formik}>
        <Form
          autoComplete="off"
          noValidate
          onSubmit={handleSubmit}
          className="grid grid-cols-1"
        >
          <FormGroup>
            <Label htmlFor="email">Email address</Label>
            <Input
              type="text"
              {...getFieldProps('email')}
              placeholder="eg: Agbamoro Victoria"
            />
          </FormGroup>
          <FormGroup>
            <InputPassword
              label="Password"
              groupClassName="input-group-merge"
              hideIcon="hide"
              showIcon="show"
              {...getFieldProps('password')}
              placeholder="Enter your password"
            />
          </FormGroup>
          <div className="w-full mb-3">
            <Label className="text-transparent " htmlFor="">
              Login
            </Label>
            <Button
              isArrow
              disabled={!(dirty && isValid)}
              className="w-full text-center"
              arrowClassName="hidden xl:block absolute right-20"
              type="submit"
            >
              Login
            </Button>
          </div>
          <div className="w-full text-base">
            Don't an account?{' '}
            <span
              className="text-primary font-bold cursor-pointer"
              onClick={openRegister}
            >
              Create an account
            </span>
          </div>
        </Form>
      </FormikProvider>
    </div>
  );
};

export default LoginForm;
